export const Dimensions = {
    header_height : 70
}